import React from 'react';
import Card from 'react-bootstrap/Card';
import Button from "react-bootstrap/Button";
import {calculateExtraCost, getSizeLabel, getSlicedStatus} from "app/shared/utils/OrderHelper";
import ARIA_LABELS from 'constants/ariaLabels';
import { SIZE_CONFIG } from 'app/shared/constants/constants';
import {ProductType} from '../types/OrderTypes';
import ButtonQuantity from "./ButtonQuantity";

type Props = {
    item: ProductType;
    addToCart: (clickedItem: ProductType) => void;
    removeFromCart: (item: ProductType) => void;
    removeGroupFromCart: (item: ProductType) => void;
    editItemFromCart: (item: ProductType) => void;

};

const CartItem: React.FC<Props> = ({
                                       item,
                                       addToCart,
                                       removeFromCart,
                                       removeGroupFromCart,
                                       editItemFromCart,
                                   }) => {
    let price: number;
    if (item.currentPrice === 0) {
        price = item.omsData.salesItems[0].currentPrice;
    } else {
        price = item.currentPrice;
    }

    const extraItems = calculateExtraCost(item.subProducts);

    return (
        <Card className="shadow-sm m-2" style={{borderRadius: '20px'}}>
            <Card.Header className="d-flex flex-column cart-header">
                <b>
                    <span aria-label={ARIA_LABELS.CART.productName} className="font-main">{item.title}</span>
                </b>
            </Card.Header>
            <Card.Body className="d-flex flex-column justify-content-between p-2">
                    <div className="horizontalAlignCenter justify-content-between">
                        <Card.Img
                            src={item.imageThumb}
                            alt={item.title}
                            style={{height: '70px', width: '70px'}}
                        />
                        <div className="itemQuantitySection">
                            <ButtonQuantity
                                itemValue="-"
                                onClick={() => removeFromCart(item)}
                                ariaLabel={ARIA_LABELS.CART.decreaseQuantity}
                            />
                            <div aria-live="polite">
                            <Card.Text className="font-sub itemQuantity" aria-label={ARIA_LABELS.CART.currentQuantity(item.amount)}>{item.amount}</Card.Text>
                            </div>
                            <ButtonQuantity
                                onClick={() => addToCart(item)}
                                itemValue="+"
                                ariaLabel={ARIA_LABELS.CART.increaseQuantity}
                            />
                        </div>
                    </div>
                    <div>
                        {SIZE_CONFIG.includes(item?.displayProductSize)
                            && (
                                <span aria-label={ARIA_LABELS.CART.size} className="font-sub">
                                    {getSizeLabel(item.displayProductSize)}
                                </span>
                            )}
                        {item?.subProducts.map((subItem) => (
                            <div className="d-flex flex-row justify-content-between font-sub" key={subItem.id}>
                                <span aria-label={ARIA_LABELS.CART.status}>
                                    {getSlicedStatus(subItem)}
                                </span>
                                <span className="font-sub" aria-label={ARIA_LABELS.CART.subItemPrice} role="note">{subItem?.price !== 0 && `(+$${subItem.price?.toFixed(2)})`}</span>
                            </div>
                        ))}
                    </div>
            </Card.Body>
            <Card.Footer className="d-flex flex-row justify-content-between align-items-center p-1 cart-footer">
                <div>
                    <Button variant="link" className="font-sub" aria-label={ARIA_LABELS.CART.removedItem} onClick={() => removeGroupFromCart(item)}>
                        Remove
                    </Button>
                    <Button variant="link" className="font-sub" aria-label={ARIA_LABELS.CART.editItem} onClick={() => editItemFromCart(item)}>
                        Edit
                    </Button>
                </div>
                <b className="m-1 font-main">
                    Total:&nbsp;
                    <span aria-label={ARIA_LABELS.CART.totalItemPrice}>
                        $
                        {(item.amount * (price + extraItems.price)).toFixed(2)}
                    </span>
                </b>
            </Card.Footer>
        </Card>
    );
};
export default CartItem;
